import { Box, LinearProgress, Sheet, Stack, Typography } from "@mui/joy";
import { motion } from "framer-motion";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";

/** Сводка «Мои тесты» из уже загруженного списка тестов (без доп. запроса).
 * props: quizzes ([{ is_completed, progress, ... }]) */
export default function MyQuizzesSummary({ quizzes }) {
  const list = quizzes || [];
  const total = list.length;
  if (total === 0) return null;

  const completed = list.filter((q) => q.is_completed).length;
  const inProgress = list.filter((q) => !q.is_completed && (q.progress || 0) > 0).length;
  const pct = Math.round((completed / total) * 100);

  return (
    <Sheet
      variant="soft"
      color="primary"
      component={motion.div}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      sx={{ borderRadius: "xl", p: 2 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            flexShrink: 0,
            background: "linear-gradient(135deg, var(--joy-palette-primary-400), var(--joy-palette-primary-600))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
          }}
        >
          <EmojiEventsRoundedIcon />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography level="title-sm">Мои тесты</Typography>
          <Typography level="body-xs" sx={{ color: "text.tertiary" }}>
            Пройдено {completed} из {total}
            {inProgress > 0 ? ` · ${inProgress} в процессе` : ""}
          </Typography>
        </Box>
        <Typography level="h4" sx={{ color: "primary.600", fontWeight: 800 }}>{pct}%</Typography>
      </Stack>
      <LinearProgress determinate value={pct} thickness={6} sx={{ mt: 1.5, borderRadius: 10 }} />
    </Sheet>
  );
}